import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dce5fe94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "graph" }
const _hoisted_2 = { class: "graph-header flex flex-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "雨量簡易グラフ", -1))
const _hoisted_4 = { class: "graph-body" }
const _hoisted_5 = { class: "current-date" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "graph-unit" }, "mm", -1))
const _hoisted_7 = { class: "graph-title" }
const _hoisted_8 = { class: "graph-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_time_seeker = _resolveComponent("time-seeker")!
  const _component_udc_select = _resolveComponent("udc-select")!
  const _component_udc_bar_graph = _resolveComponent("udc-bar-graph")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_time_seeker, {
        modelValue: _ctx.statusTime,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.statusTime) = $event)),
        resolution: _ctx.resolution
      }, null, 8, ["modelValue", "resolution"]),
      _createVNode(_component_udc_select, {
        modelValue: _ctx.resolution,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.resolution) = $event)),
        options: _ctx.spans
      }, null, 8, ["modelValue", "options"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.currentDateLabel), 1),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.graphTitle), 1),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.graphDatasets && _ctx.graphDatasets.length > 0)
          ? (_openBlock(), _createBlock(_component_udc_bar_graph, {
              key: 0,
              datasets: _ctx.graphDatasets,
              resolution: _ctx.resolution,
              thresholds: _ctx.thresholds
            }, null, 8, ["datasets", "resolution", "thresholds"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}